export function validateCRN(value: string): boolean {
  return /^\d{8}$/.test(value.trim());
}

export function validateUKVAT(value: string): boolean {
  const clean = value.replace(/^GB/i, "").replace(/\D/g, "");
  if (!/^\d{9}$/.test(clean)) return false;

  const digits = clean.split("").map(Number);
  let sum = 0;

  for (let i = 0; i < 8; i++) {
    sum += digits[i] * (8 - i);
  }

  let check = sum % 97;
  return (97 - check) === digits[8];
}

export function validateUKId(value: string): boolean {
  const clean = value.toUpperCase().trim();
  return validateCRN(clean) || validateUKVAT(clean);
}
